// extracted by mini-css-extract-plugin
module.exports = {"Webcam":"Webcam_Webcam__1pNjF"};